import { Defaults } from 'es-decorators'
import { FormView } from '../form-view'
import { handleFieldInput } from 'helpers/input-helper'
import { BankDaDataTipsView } from './bank-dadata-tips-view'
import $ from 'init/jquery'

/**
 * Вью запроса денежных средств для юридических лиц
 */
@Defaults({
  el: '',
  formElement: '.refund-field',
  events: {
    'input .js-card-number-input': 'formatCardNumber',
    'input .js-input-with-tips': 'onInputWithTipsChange',
    'input .numeric': 'onNumericInput',
  },
  errors: [],
  modelHasSaved: false,
  BIC_LENGTH: 9,
  bikError: {
    field: 'bik',
    message: 'Необходимо корректно заполнить БИК.',
  },
})
export class RefundFormView extends FormView {
  /**
   * @inheritDoc
   */
  run () {
    this.listenTo(this.model, 'sync', this.onModelSync)
    if (!this.childViews.tipsView) {
      this.childViews.tipsView = new BankDaDataTipsView({
        el: this.$('.js-input-with-tips-wrap'),
        applyTip: this.applyTip.bind(this),
        withTipsPopup: false,
      })
    }
    this.updateFieldsList()
  }

  /**
   * Выполняется при синхронизации модели.
   */
  onModelSync () {
    const currentFormData = this.model.get('bank_detail')?.[this.formName]
    if (currentFormData) {
      this.fillFormFieldsValues(currentFormData)
    }
  }

  /**
   * Заполняет банковские реквизиты из переданного объекта
   * @param {Object} bankDetails объект банковских реквизитов
   */
  fillFormFieldsValues (bankDetails) {
    if (bankDetails && this.$fields) {
      this.$fields.each((i, field) => {
        const $field = $(field)
        const attrValue = bankDetails[$field.attr('name')]
        if (attrValue) {
          $field.val(attrValue)
        }
      })
    }
  }

  /**
   * @inheritDoc
   */
  getData () {
    const data = super.getData()
    data.bank_detail_type = this.formName
    return data
  }

  /**
   * Форматирует номер карты, путём удаления всех символов кроме цифр
   * и добавляет пробел после каждой группы из 4-х цифр
   * @param {Object} event событие ввода символа
   */
  formatCardNumber (event) {
    const value = event.currentTarget.value.replace(/\D/g, '')
    const result = []
    for (let i = 0; i < value.length; i += 4) {
      result.push(value.slice(i, i + 4))
    }
    event.currentTarget.value = result.join(' ')
  }

  /**
   * Триггерит событие для запроса подсказок при вводе значения в поле
   * @param {Event} event Событие ввода символа
   */
  onInputWithTipsChange (event) {
    if (event.target.value.length === this.BIC_LENGTH) {
      this.childViews.tipsView.tipsRequest(event.target.value)
    } else {
      this.applyTip()
    }
  }

  /**
   * Срабатывает при вводе символов в инпут. Запускает хелпер.
   * @param {Event} e Событие ввода символа
   */
  onNumericInput (e) {
    handleFieldInput(e)
  }

  /**
   * Применение подсказки по банкам
   * @param {Object} tip Подсказка
   */
  applyTip (tip = {}) {
    let tipNamePayment = ''
    let tipCorrespondentAccount = ''
    if (Object.keys(tip).length) {
      tipNamePayment = tip.name.payment
      tipCorrespondentAccount = tip.correspondent_account
    }
    this.$('.make-size-for-textarea').text(tipNamePayment)
    this.$('textarea[name=name]').val(tipNamePayment)
    this.$('input[name=correspondent_account]').val(tipCorrespondentAccount)
  }

  /**
   * @inheritDoc
   */
  fillErrors (errors) {
    const formErrors = []
    errors.forEach(error => {
      const errorPathArray = error.field.split('.')
      if (errorPathArray.length > 1 && errorPathArray[1] === this.formName) {
        formErrors.push({
          field: errorPathArray[2],
          message: error.messages[0],
        })
      }
    })

    super.fillErrors(formErrors)
  }
}
